import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutos

export function useHeartbeat() {
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;

    const ping = async () => {
      try {
        await supabase.rpc('upsert_user_activity', { p_page: location.pathname });
      } catch {} // silencioso — no afecta UX
    };

    // Pequeño delay en el primer ping para asegurar que la sesión esté lista
    const firstPing = setTimeout(ping, 2000);
    const interval = setInterval(ping, HEARTBEAT_INTERVAL);
    return () => {
      clearTimeout(firstPing);
      clearInterval(interval);
    };
  }, [user, location.pathname]);
}
